import {createLogger} from 'redux-logger';

const logger = createLogger({
  'collapsed': () => true,
  'duration': true,
  'diff': true,
  'colors': {
    'title': () => '#CC8400',
    'prevState': () => '#9E9E9E',
    'action': () => '#03A9F4',
    'nextState': () => '#4CAF50',
    'error': () => '#F20404',
  },
});

export default logger;
